import { render } from "./profileHeader.vue?vue&type=template&id=1ca66a64&scoped=true"
import script from "./profileHeader.vue?vue&type=script&lang=js"
export * from "./profileHeader.vue?vue&type=script&lang=js"

import "./profileHeader.vue?vue&type=style&index=0&id=1ca66a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca66a64"]])

export default __exports__